export const customObjectsObjectRelationshipTypeSchema = "/data_objects/object_relationship_type_schema" as const;
